import React, { createContext, useContext, useMemo } from 'react'
import { useLabels } from 'src/pages/AccountSettings/AccountSettings.hooks'

const LabelsContext = createContext<Record<string, string>>({})

export const LabelsProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const { data: labelsData } = useLabels()
  const labelMap = useMemo(() => {
    const map: Record<string, string> = {}
    labelsData?.getItemsList().forEach((label) => {
      map[label.getId()] = label.getName()
    })
    return map
  }, [labelsData])

  return (
    <LabelsContext.Provider value={labelMap}>{children}</LabelsContext.Provider>
  )
}

export const useLabelMap = (): Record<string, string> =>
  useContext(LabelsContext)
